export const TITLE = "Line items";

export const CLASS_NAMES = {
  container: "mb-6",
  title: "text-style-f-em text-neutral-800 mb-6",
  footer: "px-6",
  content: "mb-6",
};
